import { Dialog } from '@mui/material';
import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Outlet, useLocation } from 'react-router-dom';
import { IdleTimerConfirmation } from './IdleTimerConfirmation';
import { URLRoutes } from '../../config/web';
const SECONDS = 5;

export const IdleTimer = () => {

  return (
    <>
        <Outlet />
        <IdleTimerConfirmation />
    </>
  )
}
